<template>
    <el-container>
        <el-header>
            <Header/>
        </el-header>
        <el-container>
            <el-aside :width="!isCollapse?'200px':'70px'">
                <div class="collapse-icon" @click.stop="isCollapse=!isCollapse"> <i class="iconfont icon-jiantou-xiangzuo"></i></div>
                <el-menu
                    :default-active="currentRoutePath"
                    :collapse="isCollapse"
                    @open="handleOpen"
                    @close="handleClose"
                    active-text-color="#1477C9"
                    text-color="#333"
                    background-color="#E4EAF7"
                    router
                >

                    <template v-for='item in routeList' :key='item.path'>
                        <template v-if='!item.hidden'>
                            <template v-if='item.children.length === 1'>
                                <!-- <template v-else>  如果没有其他的情况，使用这个也可以代替上面一个判断-->
                                <el-menu-item :index='item.path+`/index`'>
                                    <el-icon><el-image :src="require(`./image/${item.children[0].img}.png`)"/></el-icon>
<!--                                    <i class="iconfont" :class="item.children[0].icon"></i>-->
                                    {{ item.children[0].title }}
                                </el-menu-item>
                            </template>
                            <el-sub-menu v-if='item.children&&item.children.length > 1' :index='item.path+`/index`'>
                                <template #title>
                                    <el-icon><el-image :src="require(`./image/${item.img}.png`)"/></el-icon>
                                    <div>{{ item.title }}</div>
                                    <el-icon v-if="!isCollapse" class="select-menu-icon"><CaretBottom/></el-icon>
                                </template>
                                <el-menu-item-group v-for='child in item.children' :key='child.path'>
                                    <el-menu-item :index="item.path+`/`+child.path" :class="{'second-box':isCollapse}">
                                        <span >{{ child.title }}</span>
                                    </el-menu-item>
                                </el-menu-item-group>
                            </el-sub-menu>
                        </template>
                    </template>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script setup>
import {CaretBottom} from "@element-plus/icons-vue";
import {onMounted, ref, watch} from "vue";
import {onBeforeRouteUpdate, useRouter} from "vue-router";
import Header from '@/components/header/index'
import request from "@/service/request";
import {getGlobalConfig} from "@/service/api";
import {analysisTime} from "@/tool/public";

console.log(useRouter().currentRoute)

const isCollapse = ref(false)
const router = useRouter()

const routeList = router.options.routes

const currentRoutePath = ref('/home/index')

watch(() =>router.currentRoute.value.path,(newValue,oldValue)=> {
    currentRoutePath.value = newValue
},{ immediate: true })


const handleOpen = (key, keyPath) => {
    console.log(key, keyPath)
}
const handleClose = (key, keyPath) => {
    console.log(key, keyPath)
}

// const getInfo = async () => {
//     let {data} = await request({
//         url: getGlobalConfig
//     })
//     if (data.latestQuarter) {
//         localStorage.setItem('time', analysisTime(data.latestQuarter))
//         localStorage.setItem('mapTime', data.latestQuarter)
//         localStorage.setItem('cityList', JSON.stringify(data.cityList || []))
//     }
// }
// onMounted(async () => {
//    await getInfo()
// })
</script>


<style scoped lang="less">
.el-container {
    height: 100%;
    background: #F8F8F8;
    overflow: hidden;

    .el-header {
        height: 54px;
        background: #102451;
    }

    .el-aside {
        height: 100%;
        background: #E4EAF7;
        position: relative;
        .el-menu {
            .el-menu-item:hover{
                background-color:#E4EAF7;
            }

            padding-top:20px;
            ::v-deep .el-menu-item-group__title{
                display: none;
            }
            ::v-deep .el-sub-menu__title{

                .el-sub-menu__icon-arrow{
                    width: 0;
                    display: none!important;
                }
                .select-menu-icon {
                    position: absolute;
                    top: 50%;
                    right: var(--el-menu-base-level-padding);
                    margin-top: -6px;
                    transition: transform var(--el-transition-duration);
                    font-size: 12px;
                    margin-right: 0;
                }
            }
            .is-active{
                .el-sub-menu__title{
                    &>div {
                        color: #1477C9;
                    }
                }
                .is-active{
                    &>span {
                        width: 150px;
                        height: 36px;
                        background: linear-gradient(90deg, #2B90E4 0%, #4BADFF 99%);
                        border-radius: 8px;
                        color: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: -20px;
                    }


                }
            }
            .is-opened{

                .select-menu-icon{
                    transform: rotateZ(180deg)
                }
            }
            border: 0;


        }

        .el-menu--collapse {
            width: 70px;
            min-height: 400px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .el-menu-item{
                display: flex;
                flex-direction: column;
                font-size: 12px;
                width: 58px;
                height: 56px;
                border-radius: 6px;
                justify-content: space-around;
                line-height: 1;

            }
            .el-menu-item.is-active {
                background: #F9FBFC;

            }
            .el-sub-menu.is-active{
                ::v-deep .el-sub-menu__title{
                    background: #F9FBFC!important;
                }

            }

            ::v-deep .el-sub-menu__title{
                margin-top: 15px;
                display: flex;
                flex-direction: column;
                font-size: 12px;
                width: 58px;
                height: 56px;
                border-radius: 6px;
                justify-content: space-around;
                line-height: 1;
                padding: 0!important;
                .seconds-icon {
                    width: auto;
                    height: auto;
                }
            }
        }

        .collapse-icon{
            position: absolute;
            right: 0;
            top: 15px;
            width: 20px;
            height: 25px;
            background: #B7D9F9;
            border-radius: 13px 0px 0px 13px;
            z-index: 99;
            display: flex;
            align-items: center;
            justify-content: center;
            &>.iconfont {
                font-size: 12px;
                color: #1477C9;
            }
        }
    }
    .el-main {
        padding: 0;
    }


}
</style>